import { MIN_PASSWORD_LENGTH } from './util_password';

// Firebase Auth error codes, translated for the people who see them.
//
// Shared by everything that talks to Firebase Auth — the sign-in screen, both
// invitation flows, and the email action handler — so a concierge meets the
// same words whichever door they came through.

/** Maps Firebase auth error codes to something a concierge can act on. */
export function authErrorMessage(e: unknown): string {
  switch ((e as { code?: string }).code) {
    case 'auth/invalid-email':
      return 'That email address does not look right.';
    case 'auth/missing-password':
      return 'Please enter a password.';
    case 'auth/weak-password':
      return `Please use a password of at least ${MIN_PASSWORD_LENGTH} characters.`;
    case 'auth/email-already-in-use':
      return 'An account already exists for this address. Sign in with your password instead.';
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
      return 'Wrong email or password.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please wait a moment and try again.';

    // Email action links. Firebase does not distinguish "already used" from
    // "malformed" — both arrive as invalid-action-code — so the message has to
    // cover both, and the remedy is the same either way.
    case 'auth/expired-action-code':
      return 'This link has expired. Please request a new one.';
    case 'auth/invalid-action-code':
      return 'This link is no longer valid. It may already have been used — please request a new one.';
    case 'auth/user-disabled':
      return 'This account has been disabled. Please contact Eighty Days.';

    default:
      return 'Sign-in failed. Please try again.';
  }
}
